import { render } from "./Discovery.vue?vue&type=template&id=048ad00e&scoped=true"
import script from "./Discovery.vue?vue&type=script&lang=js"
export * from "./Discovery.vue?vue&type=script&lang=js"

import "./Discovery.vue?vue&type=style&index=0&id=048ad00e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048ad00e"]])

export default __exports__